import { useState } from 'react';
import SubVisual from '@/components/SubVisual';
import { Outlet } from 'react-router';
import PolicySelectBox from '@/pages/policy/components/PolicySelectBox';
import { privacySelectItem, privacyTab } from '@/pages/policy/constants';

const PrivacyPage = () => {
	const [activeTab, setActiveTab] = useState(0);

	const handleTabChange = (index: number) => {
		setActiveTab(index);
	};

	return (
		<main id="privacy" className={`sub terms privacy`}>
			<SubVisual
				title={privacyTab.subTab[activeTab].title}
				subTab={privacyTab.subTab}
				cate={''}
				onChangeTab={handleTabChange}
			/>
			<section className="sub-content">
				<div className="sub-inner">
					{activeTab === 0 && <PolicySelectBox selectItems={privacySelectItem} />}
					<Outlet />
				</div>
			</section>
		</main>
	);
};

export default PrivacyPage;
